import axios from 'axios'
import { host } from './base.api.js'

const url = {
  orderList: host + '/api/socialagent/order/list',
  orderCommission: host + '/api/socialagent/order/commission',
  orderInvoice: host + '/api/socialagent/order/invoice',
  creditCardOrderCount: host + '/api/socialagent/order/creadicard/count',
  queryAgentsOfCurrentUserInvited: host + '/api/socialagent/order/invitational',
  getOrderState: host + '/api/socialagent/order/orderNodeStatus',
  getOrderNode: '/api/order/businessLineAndOrderStatus',
  getSettlementList: "/api/socialagent/order/getUserNewSettlementList"
}

export default {
  // 获得订单列表
  getOrders({
    beginTime,
    endTime,
    businesslineIds,
    orderNodeIds,
    customerLabelIds,
    matchingFields,
    dataType,
    businessType,
    checkType,
    pageSize = 10,
    pageIndex = 1,
  }) {
    var http = axios.post(url.orderList, {
      beginTime,
      endTime,
      businesslineIds,
      orderNodeIds,
      customerLabelIds,
      matchingFields,
      dataType,
      businessType,
      checkType,
      pageSize: pageSize,
      pageNo: pageIndex,
      t: new Date().getTime(),
    });
    return http;
  },
  // 获取订单状态列表
  getOrderStateList(orderId, businessType) {
    var http = axios.get(
      url.getOrderState +
        "?" +
        `orderId=${orderId}&businessType=${businessType ? businessType : ""}`
    );
    return http;
  },
  // 获得佣金列表
  getCommission({
    commissionType = "",
    date = "",
    pageSize = 10,
    pageIndex = 1,
    secondPlatformAgentId = "",
  }) {
    console.log(commissionType);
    var http = axios.get(url.orderCommission, {
      params: {
        commissionType: commissionType,
        date: date,
        pageSize: pageSize,
        pageNo: pageIndex,
        secondPlatformAgentId: secondPlatformAgentId,
        t: new Date().getTime(),
      },
    });
    return http;
  },
  // 上传发票
  addInvoice({ orderId, wxMediaId, imgData }) {
    var http = axios.post(url.orderInvoice, {
      orderId: orderId,
      invoiceBase64: imgData,
      wxMediaId: wxMediaId,
      t: new Date().getTime(),
    });
    return http;
  },
  // 获得信用卡订单数量
  getCreditCardOrderCount() {
    var http = axios.get(url.creditCardOrderCount, {
      params: {
        t: new Date().getTime(),
      },
    });
    return http;
  },
  queryAgentsOfCurrentUserInvited({
    pageIndex,
    pageSize,
    registerDate,
    sortType,
  }) {
    return axios.get(url.queryAgentsOfCurrentUserInvited, {
      params: {
        pageIndex,
        pageSize,
        registerDate,
        sortType,
      },
    });
  },
  // 获取订单节点
  getOrderNodeList() {
    return axios.get(url.getOrderNode + "?businessLineId=1501,1801,1001");
  },
  // 获取结算列表
  getSettlementList({ PlatformAgentID, pageNo, matchingFields }) {
    return axios.post(
      url.getSettlementList +
        "?" +
        `PlatformAgentID=${PlatformAgentID}&pageNo=${pageNo}&matchingFields=${matchingFields}&t=${new Date().getTime()}`
    );
  },
};



// WEBPACK FOOTER //
// ./src/api/order.js